import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'react-bootstrap';

/**
 * Base component for Settings detail modals (Keywords, Templates).
 * Handles the common modal structure: header, body with form, footer with close/save buttons.
 * Each specific modal provides its own form content via the `children` prop.
 */
const DetailModalBase = ({
  show,
  onHide,
  title,
  saveLabel,
  onSave,
  size = undefined,
  children,
  comments = '',
  onCommentsChange = undefined,
}) => {
  return (
    <Modal show={show} onHide={onHide} size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {children}
          {onCommentsChange && (
            <Form.Group>
              <Form.Label>Comment</Form.Label>
              <Form.Control
                value={comments || ''}
                onChange={(e) => onCommentsChange(e.target.value)}
                as="textarea"
                rows={3}
                placeholder="Enter comments"
              />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={onSave}>
          {saveLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DetailModalBase.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  saveLabel: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  size: PropTypes.string,
  children: PropTypes.node.isRequired,
  comments: PropTypes.string,
  onCommentsChange: PropTypes.func,
};

export default DetailModalBase;
